import ApiService from '@/services/ApiService';

export default {
  getAll() {
    return ApiService().get('/user/list');
  },
  getList() {
    return ApiService().get('/commission/list');
  },
  payCommission(staff) {
    return ApiService()
      .put('/commission/pay', { staffId: staff.staffId, amount: staff.amount });
  },

  checkStaffCommission(staffId, productId) {
    return ApiService().get(`/commission/match/${staffId}/${productId}`, false, true);
  },
  printReportCommissions() {
    return ApiService().post('/commission/print-report-by-workday');
  },
};
